import { render, staticRenderFns } from "./AssetUpload.vue?vue&type=template&id=1cf4fe2c&scoped=true&"
import script from "./AssetUpload.vue?vue&type=script&lang=js&"
export * from "./AssetUpload.vue?vue&type=script&lang=js&"
import style0 from "./AssetUpload.vue?vue&type=style&index=0&id=1cf4fe2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf4fe2c",
  null
  
)

export default component.exports